export const parse = objectToParse =>
  typeof objectToParse === 'string'
    ? JSON.parse(objectToParse)
    : objectToParse;

export const localize = (objectToLocalize, region) =>
  objectToLocalize?.[region]
    || objectToLocalize?.['default']
    || objectToLocalize;